// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuoData_crollImg {
  border-radius: 1.5vh;
}

.ant-image .ant-image-mask {
  border-radius: 1.5vh !important;
  background: linear-gradient(0deg, rgba(240, 89, 42, 0.5) 0%, rgba(240, 89, 42, 0.5) 100%);
}

.nuoDataText {
  margin-left: 2vw;
}

.carouselItem {
  padding: 0 1vw;
}

@media (min-width: 1600px) {
  .h1TagText {
    margin-top: 4vw;
    color: #fff;
    font-family: Roboto;
    font-size: 2.5vw;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}
@media (max-width: 1599px) {
  .define {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
  .h1TagText {
    margin-top: 60px;
    color: #fff;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}
@media (max-width: 1200px) {
  .define {
    color: #fff;
    text-align: center;
    /* UI/T04-Reg-Med-Bold */
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
  .h1TagText {
    margin-top: 60px;
    color: #fff;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}
@media (max-width: 992px) {
  .define {
    color: #fff;
    text-align: center;
    /* UI/T04-Reg-Med-Bold */
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
  .h1TagText {
    margin-top: 60px;
    color: #fff;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}
@media (max-width: 768px) {
  .define {
    color: #fff;
    text-align: center;
    /* UI/T04-Reg-Med-Bold */
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
  .h1TagText {
    margin-top: 60px;
    color: #fff;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}
@media (max-width: 576px) {
  .define {
    color: #fff;
    text-align: center;
    /* UI/T04-Reg-Med-Bold */
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
  .h1TagText {
    margin-top: 60px;
    color: #fff;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 42px */
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/NuoDataProduct/nuodata.scss"],"names":[],"mappings":"AAAA;EAEE,oBAAA;AAAF;;AAGA;EACE,+BAAA;EACA,yFAAA;AAAF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EAME;IACE,eAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EATF;AACF;AAWA;EAKE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAbF;EAeA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAbF;AACF;AAeA;EAKE;IACE,WAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAjBF;EAmBA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAjBF;AACF;AAmBA;EAME;IACE,WAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAtBF;EAwBA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAtBF;AACF;AAwBA;EAME;IACE,WAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EA3BF;EA6BA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EA3BF;AACF;AA6BA;EAME;IACE,WAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAhCF;EAkCA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAhCF;AACF","sourcesContent":[".nuoData_crollImg {\n  // width: 30vw !important;\n  border-radius: 1.5vh;\n}\n\n.ant-image .ant-image-mask {\n  border-radius: 1.5vh !important;\n  background: linear-gradient(\n    0deg,\n    rgba(240, 89, 42, 0.5) 0%,\n    rgba(240, 89, 42, 0.5) 100%\n  );\n}\n\n.nuoDataText {\n  margin-left: 2vw;\n}\n\n.carouselItem {\n  padding: 0 1vw;\n}\n\n@media (min-width: 1600px) {\n  .nuoData_crollImg {\n    // width: 40vw !important;\n    // margin-left: 4vw;\n  }\n\n  .h1TagText {\n    margin-top: 4vw;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 2.5vw;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n@media (max-width: 1599px) {\n  .nuoData_crollImg {\n    // width: 40vw !important;\n    // margin-left: 4vw;\n  }\n  .define {\n    color: #fff;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n  .h1TagText {\n    margin-top: 60px;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n@media (max-width: 1200px) {\n  .nuoData_crollImg {\n    // width: 40vw !important;\n    // margin-left: 4vw;\n  }\n  .define {\n    color: #fff;\n    text-align: center;\n    /* UI/T04-Reg-Med-Bold */\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n  .h1TagText {\n    margin-top: 60px;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n@media (max-width: 992px) {\n  .nuoData_crollImg {\n    // width: 80vw !important;\n    // height: 40vw !important;\n    // margin-left: 4vw;\n  }\n  .define {\n    color: #fff;\n    text-align: center;\n    /* UI/T04-Reg-Med-Bold */\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n  .h1TagText {\n    margin-top: 60px;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n@media (max-width: 768px) {\n  .nuoData_crollImg {\n    // width: 90vw !important;\n    // height: 50vw !important;\n    // margin-left: 4vw;\n  }\n  .define {\n    color: #fff;\n    text-align: center;\n    /* UI/T04-Reg-Med-Bold */\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n  .h1TagText {\n    margin-top: 60px;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n@media (max-width: 576px) {\n  .nuoData_crollImg {\n    // width: 90vw !important;\n    // height: 50vw !important;\n    // margin-left: 4vw;\n  }\n  .define {\n    color: #fff;\n    text-align: center;\n    /* UI/T04-Reg-Med-Bold */\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n  .h1TagText {\n    margin-top: 60px;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 42px */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
